module.exports = __webpack_public_path__ + "img/CustomPrograms-bgm.ddcf4e9d.png";